import { AccountBody, forgetPasswordApis } from '@apis/forgetPasswordApis';
import { useMutation } from '@hooks/useMutation';
import { FormError } from '@utils/errors';

export const useForgetPassword = () => {
  return useMutation(async (body: AccountBody) => {
    const response = await forgetPasswordApis.post('/password/reset/', { body });
    if (response[400]) {
      throw new FormError('RegistrationError', response[400]);
    }
    return response[200]!;
  });
};
